
export default function updatePhones() {
    return {
        mobileCountry: [],
        businessCountry: [],
        homeCountry: [],
        phones: {
            mobile: { country: '', phone: '', isPrimary: false, phoneType: 0 },
            business: { country: '', phone: '', isPrimary: false, phoneType: 0 },
            home: { country: '', phone: '', isPrimary: false, phoneType: 0 },
        },

        passedBusinessCountry: '',
        passedBusinessPhone: '',

        passedmobileCountry: '',
        passedmobilePhone: '',

        passedhomeCountry: '',
        passedhomePhone: '',

        isBusinessCountry: true,
        isBusinessPhone: true,

        ismobileCountry: true,
        ismobilePhone: true,

        ishomeCountry: true,
        ishomePhone: true,

        isBusinessCountryError: '',
        isBusinessPhoneError: '',

        ismobileCountryError: '',
        ismobilePhoneError: '',

        ishomeCountryError: '',
        ishomePhoneError: '',

        primaryPhone: '',
        
        phoneDetails: '',
        zotAlertChecked: false,
        seasonList: [],
        seasonFistTermYear:'',
        fetchCountry() {
            fetch(' /api/common/GetCountries')
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                })
                .then((json) => {
                    this.mobileCountry = json;
                    this.businessCountry = json;
                    this.homeCountry = json;
                    this.bindProfile();
                   
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        mobilePhoneZotAlertClick() {
            this.zotAlertChecked = true;
        },
       
        formatPhoneNumber(phoneNumber) {
            if (phoneNumber.length === 10) {
                var maskedPhone = "";
                phoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
                const match = phoneNumber.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
                maskedPhone = match ? `(${match[1]}) ${match[2]}-${match[3]}` : ''
                return maskedPhone;
            }
            else if (phoneNumber.length > 10) {

                var maskedPhone = "";
                phoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
                phoneNumber = phoneNumber.substring(0, 10);
                const match = phoneNumber.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
                maskedPhone = match ? `(${match[1]}) ${match[2]}-${match[3]}` : ''
                return maskedPhone;
            }
            else {
                return "";
            }
        },
        formatCellNumber(countryCode, phoneNumber)
        {
            if (countryCode === '261') {
                this.phones.mobile.phone = this.formatPhoneNumber(phoneNumber);
            }
            else {
                this.phones.mobile.phone = phoneNumber.replace(/\D/g, '');
            }

        },
        formatHomeNumber(countryCode, phoneNumber) {
            if (countryCode === '261') {
                this.phones.home.phone = this.formatPhoneNumber(phoneNumber);
            }
            else {
                this.phones.home.phone = phoneNumber.replace(/\D/g, '');
            }

        },
        formatWorkNumber(countryCode, phoneNumber) {
            if (countryCode === '261') {
                this.phones.business.phone = this.formatPhoneNumber(phoneNumber);
            }
            else {
                this.phones.business.phone = phoneNumber.replace(/\D/g, '');
            }

        },
        bindSeasonList() {

            fetch('/api/ProgramAPI/GetSeasonList?top=' + 2, { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(this.seasonList, response.seasons)
                        this.seasonFistTermYear = this.seasonList[0].academicTerm.toUpperCase() + this.seasonList[0].academicYear;
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        bindProfile() {

            fetch('/api/UserAPI/GetProfile', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.zotAlertChecked = response.zotAlertChecked;
                        this.bindPhoneDetails();
                    } else {
                        window.location.href = '/api/login/SignOut';
                    }

                });

        },

        bindPhoneDetails() {

            fetch('/api/checkout/get-phone-details', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.phoneDetails = response.phoneDetails;
                        this.phones.mobile.phone = this.phoneDetails.cellPhoneCountryId === 261? this.formatPhoneNumber(this.phoneDetails.cellPhone) : this.phoneDetails.cellPhone;
                        this.phones.mobile.country = this.phoneDetails.cellPhoneCountryId.toString();
                        this.phones.business.phone = this.phoneDetails.workPhoneCountryId === 261? this.formatPhoneNumber(this.phoneDetails.workPhone) : this.phoneDetails.workPhone;
                        this.phones.business.country = this.phoneDetails.workPhoneCountryId.toString();;
                        this.phones.home.phone = this.phoneDetails.homePhoneCountryId === 261? this.formatPhoneNumber(this.phoneDetails.homePhone) : this.phoneDetails.homePhone;
                        this.phones.home.country = this.phoneDetails.homePhoneCountryId.toString();;
                        this.primaryPhone = this.phoneDetails.primaryPhone;
                        if (this.primaryPhone == "HOME") {
                            this.phones.home.isPrimary = true;
                        }
                        if (this.primaryPhone == "WORK") {
                            this.phones.business.isPrimary = true;
                        }
                        if (this.primaryPhone == "CELL") {
                            this.phones.mobile.isPrimary = true;
                        }
                        this.bindSeasonList();
                    } else {
                        this.showErrorMesage = "Something went wrong."
                    }

                });

        },

        init() {
            this.fetchCountry();
        }
    }
}